import { Controller } from '@hotwired/stimulus'

// Self-dismissing success toast. Fades/slides in on connect and removes itself
// after the configured delay (matches the design's 2600ms auto-dismiss).
export default class extends Controller {
  static values = { delay: { type: Number, default: 2600 } }

  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove('opacity-0', 'translate-y-3')
    })
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.classList.add('opacity-0', 'translate-y-3')
    this.element.addEventListener(
      'transitionend',
      () => this.element.remove(),
      { once: true }
    )
  }
}
